"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesEnum = void 0;
var ServicesEnum;
(function (ServicesEnum) {
    ServicesEnum["IDENTITY"] = "identity";
    ServicesEnum["COMMERCE"] = "commerce";
    ServicesEnum["ENROLLMENT"] = "enrollment";
    ServicesEnum["OTK_IDENTITY"] = "otk_identity";
    ServicesEnum["LMNT"] = "lmnt";
})(ServicesEnum || (exports.ServicesEnum = ServicesEnum = {}));
